/**
 * Copied from V1 Tagging/components/shared/VisualizationContainer/svg/
 * ContactPointVis.tsx so the design can diverge. Props-only: no Redux.
 */

import { BALL_FILL, STROKE_FILL } from "./colors";

interface Props {
  className?: string;
  xFeet?: number;
  yFeet?: number;
  "data-testid"?: string;
}

export const ContactPointVis: React.FC<Props> = ({
  className,
  xFeet,
  yFeet,
  "data-testid": testId,
}) => {
  return (
    <svg
      data-testid={testId}
      className={className ?? "w-full"}
      viewBox="0 0 650 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M234 306H416V402.688L325 488L234 402.688V306Z"
        fill={STROKE_FILL}
        fillOpacity="0.21"
      />
      <rect
        x="127"
        y="198"
        width="43"
        height="302"
        fill="url(#paint0_linear_994_1799)"
      />
      <rect
        x="480"
        y="198"
        width="43"
        height="302"
        fill="url(#paint1_linear_994_1799)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_994_1799"
          x1="148.5"
          y1="198"
          x2="148.5"
          y2="500"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={STROKE_FILL} stopOpacity="0" />
          <stop offset="0.619792" stopColor={STROKE_FILL} stopOpacity="0.21" />
          <stop offset="1" stopColor={STROKE_FILL} stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_994_1799"
          x1="501.5"
          y1="198"
          x2="501.5"
          y2="500"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={STROKE_FILL} stopOpacity="0" />
          <stop offset="0.619792" stopColor={STROKE_FILL} stopOpacity="0.21" />
          <stop offset="1" stopColor={STROKE_FILL} stopOpacity="0" />
        </linearGradient>
      </defs>

      {/* In this svg, 1 inch corresponds to 10.7058823529px. xFeet is the distance on x axis
          from the origin, yFeet is distance on y axis from origin. Origin (0, 0) is located
          at tip of home plate on the svg, which corresponds to pixel (325, 358) measured from
          top left corner of SVG. xFeet and yFeet are multiplied by 128.47 to convert FEET into
          PX to paint the SVG of the ball */}

      {xFeet != null && yFeet != null && (
        <circle
          cx={325 + xFeet * 128.47}
          cy={488 - yFeet * 128.47}
          r="15.8"
          fill={BALL_FILL}
        />
      )}
    </svg>
  );
};
